import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chart\">\n  <path d=\"M4 19.5h16\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n  <path d=\"M6.5 16v-5.5h3V16h-3ZM10.5 16V5h3v11h-3ZM14.5 16V8h3v8h-3Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol